import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { AuthService } from '../../../Services/auth.service';
import { BaseApiService } from '../../../Services/base-api.service';
import { ImageUploadService } from '../../../Services/image-upload.service';
import { RichTextEditorService } from '../../../Services/rich-text-editor.service';


@Component({
  selector: 'app-add-blog-post',
  templateUrl: './add-blog-post.component.html',
  styleUrls: ['./add-blog-post.component.css'],standalone:false

})
export class AddBlogPostComponent implements OnInit{
  form!: FormGroup;
  editorContent: string = "";
  imageUrl: string = '';
  loading:boolean=false;
  userId:string;
  constructor
  (
  private repository:BaseApiService,
  private messageService:MessageService,
  private editorService: RichTextEditorService,
  private imageUploadService:ImageUploadService,
  private auth:AuthService
  )
{

  this.userId=this.auth.getUID();
}

  onSubmit() {
    this.loading=true
    if (this.form.valid) {

      const formValues = this.form.value;
      this.repository.create("Blog", formValues).subscribe((response) => {
        this.loading=false;
        window.location.reload();
        this.messageService.add({ severity: 'success', summary: 'Success', detail: response.message });
      }
      ,(error)=>
      {
       
        this.loading=false;

        this.messageService.add({ severity: 'error', summary: 'Error', detail: error });
      }
      );
    } else {
         this.loading=false;
    }


  }


initform(){
  this.form = new FormGroup({

    title: new FormControl('', [Validators.required]),
    description: new FormControl('', [Validators.required]),
    metaDescription: new FormControl('', [Validators.required]),
    image:new FormControl('', [Validators.required]),
    userId: new FormControl('',[Validators.required])
  });
}

 ngOnInit(): void {

  this.editor();
   this.initform();
   this.form.get('userId')?.setValue(this.userId);
 }


 editor() {
  this.editorService.getEditorContent().subscribe(content => {
    this.editorContent = content;
    this.form.get('description')?.setValue(this.editorContent);
  });

}


upload(event: any): void {
  this.loading=true
  const file: File = event.target.files[0];
  if (file) {

   this.imageUploadService.uploadImage(file)
   .subscribe
   ((imageUrl: string) => {
     this.imageUrl = imageUrl;
    
     this.form.get('image')?.setValue(imageUrl);
     this.loading=false;
   }
   ,(error)=>{
    {
      this.loading=false;
      this.messageService.add({ severity: 'error', summary: 'Error', detail: error });

    }
   }
   );


  }
}


}
